export const tiles = [
    ["e","we","we","we","we","we","we","we","we","ws"],
    ["se","we","we","we","we","we","we","we","we","nw"],
    ["ne","we","we","we","we","we","we","we","we","ws"],
    ["se","we","we","we","we","we","we","we","we","nw"],
    ["ne","we","we","we","we","we","we","we","we","ws"],
    ["se","we","we","we","we","we","we","we","we","nw"],
    ["ne","we","we","we","we","we","we","we","we","ws"],
    ["se","we","we","we","we","we","we","we","we","nw"],
    ["ne","we","we","we","we","we","we","we","we","ws"],
    ['e',"we","we","we","we","we","we","we","we","w"],
]


/*




*/



